(()=>{
  function initJCIRechargeCustomizations(e) {
    var bundlingApp = document.getElementById('bundling-app');
    if (!bundlingApp) return;

    waitForItToLoad( bundlingApp, customizeRechargeBundle );
  };

  function waitForItToLoad (bundlingApp, callback) {

    var config = { 
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true
    };
    var mutationCallback = (mutationList, observer) => {
      var isReady = false;
      for (var i=0; i < mutationList.length; i++) {
        var mutation = mutationList[i];
        if (mutation.type === 'childList' && mutation.target.matches('#build-a-box')) {
          isReady = true;  
        }
      }

      if (isReady) {
        observer.disconnect();
        callback(bundlingApp);
      }
    };
    var observer = new MutationObserver(mutationCallback);
    observer.observe(bundlingApp, config);

  }

  function customizeRechargeBundle (bundle) {
    injectCSS();
    addCollectionTabsToRechargeBundle( bundle );

    makeCollectionsCollapsible( bundle );
    // Keep on converting every second as Recharge seems to be deferring the loading some of the collections.
    let makeCollectionsCollapsibleCallsCounter = 0;
    const intervalId = setInterval(() => { 
      console.log('JCI: Checking for Recharge Changes to Categories... (' + makeCollectionsCollapsibleCallsCounter + ')');
      //debugger;
      addCollectionTabsToRechargeBundle( bundle );
      makeCollectionsCollapsible(bundle); 
      if (makeCollectionsCollapsibleCallsCounter++ >= 10) {
        console.log('JCI: Giving up... (assuming all changes have loaded by now)');
        clearInterval(intervalId);
      }
    }, 1000 );

    addAdditionalSummaryDetailsToRechargeBundle( bundle );
    applyCustomTierTitlesToRechargeBundle( bundle );
  }

  function makeCollectionsCollapsible( bundle ) {
    bundle.querySelectorAll('.rb-section-header:not(.jci-collapsible-initialized)').forEach ( (header,i,headers) => {

      let duration = 500;
      let target = header.nextElementSibling;

      console.log('makeCollectionsCollapsible: Processing ' + i );
      console.log(header);

      /* Collapse all except first tab */
      if (!header.parentElement.matches(':first-of-type')) {
        slideUp(target, duration);
      }


      header.addEventListener('click', e => {
        if (window.getComputedStyle(target).display === 'none') {
          header.classList.add('jci-open');
          return slideDown(target, duration);
        } else {
          header.classList.remove('jci-open');
          return slideUp(target, duration);
        }
      });
      header.classList.add('jci-collapsible-initialized');
    });
  }

  function applyCustomTierTitlesToRechargeBundle( bundle ) {
    if (typeof(window.jci_custom_bundle_tier_titles) === 'undefined') return;

    var target = bundle.querySelector('#build-a-box'); 

    var config = { 
      subtree: true,
      childList: true
    };

    var mutationCallback = (mutationList, observer) => {
      

      for (var i=0; i < mutationList.length; i++) {
        var mutation = mutationList[i];

        if (mutation.type === 'childList') {
          for (var j=0; j < mutation.addedNodes.length; j++) {
            var addedNode = mutation.addedNodes[j];
            if (addedNode.nodeType === Node.ELEMENT_NODE && 
              addedNode.matches('.rb-container') &&
              (addedNode.querySelector('.rb-incentives-status__container')?.matches('.rb-container > .rb-incentives-status__container') ?? false)) { 
              updateTierTitles(addedNode);
            }
          }
        }
      }
    };

    var observer = new MutationObserver(mutationCallback);
    observer.observe(target, config);
  }

  function updateTierTitles(addedNode) {

    // Another observer to catch changes to the tiers (specifically the flex-grow)
    var tierObserver = new MutationObserver((mutationList, observer) => {
      for (var i=0; i < mutationList.length; i++) {
        var mutation = mutationList[i];
        if (mutation.type === 'attributes' && mutation.target.matches('.tflex-column[data-flex-grow]') && mutation.attributeName === 'style') {
          mutation.target.style['flex-grow'] = mutation.target.dataset.flexGrow;
        }
      }
    });

    var maxQty = addedNode.querySelectorAll('.rb-incentives-status__container > .tflex-l .tmr1')?.length ?? 0;
    var tiers = addedNode.querySelectorAll('.rb-incentives-status__container > .tflex-l .tflex-column');
    var mobileTiers = addedNode.querySelectorAll('.rb-incentives-status__container .tflex.tdn-l > .tflex-column > .tflex');

    var flexGrow = 0;
    var tierIdx = 0;
    for( var k=0; k < maxQty; k++) {
      var qty = k + 1;

      flexGrow++;

      var customTierIdx = window.jci_custom_bundle_tier_titles.quantity.findIndex(el => el === qty);
      if (customTierIdx < 0 ) {
        continue;
      }

      var title = window.jci_custom_bundle_tier_titles.title[customTierIdx];
      var tier = tiers[tierIdx];
      var mobileTier = mobileTiers[tierIdx];

      if (tier.style['flex-grow'] == flexGrow) {
        /* Change directly */
        tier.querySelector('.incentive-tier__title').textContent = title;
        mobileTier.querySelector('.incentive-tier__title').textContent = title;
        tierIdx++;
      } else if (tier.style['flex-grow'] < flexGrow) {
        /* Next */
        tierIdx++;
      } else if (tier.style['flex-grow'] > flexGrow) {
        /* Create */
        tier.insertAdjacentHTML('beforebegin',`<div class="tflex tflex-column titems-end" style="flex: ${ flexGrow } 1 0%;" data-v-d7cb7c="" data-v-139d5d=""><span class="incentive-tier__quantity tjustify-end titems-center" data-v-d7cb7c=""><!----> Add ${ qty },</span><span class="tflex incentive-tier__title tmb2" data-v-d7cb7c="">${ title }</span></div>`);
        mobileTier.insertAdjacentHTML('beforebegin',`<div class="tflex titems-end tw-100" style="flex: ${ qty } 1 0%;" data-v-6740af="" data-v-544ea1=""><div class="tflex titems-center tjustify-between tw-100" data-v-6740af=""><span class="tflex tflex-row" data-v-6740af=""><span class="incentive-tier__quantity tmr1" data-v-6740af="">Add ${ qty },</span><span class="incentive-tier__title" data-v-6740af="">${ title }</span></span><!----></div></div>`);

        tier.dataset.flexGrow = (tier.style['flex-grow'] - flexGrow);
        tier.style['flex-grow'] = tier.dataset.flexGrow;
        tierObserver.observe(tier, { 'attributes': true });

      }  

      /* Reset flexGrow */
      flexGrow = 0;
    }
  }

  function addAdditionalSummaryDetailsToRechargeBundle( bundle ) {
    buildABox = bundle.querySelector('#build-a-box'); 
    buildABox.insertAdjacentHTML('beforeend',`
      <div id="jci-recharge-bundle--summary" class="jci-recharge-bundle--summary">
        <h5>Your Bundle Summary</h5>
        <p class="jci-recharge-bundle--summary-tier-savings" data-jci-custom-sync="savings"></p>

        <button class="jci-recharge-bundle--summary-add-to-cart button button--small" disabled="" data-jci-custom-sync="addtocart">Add to cart<span class="tstrike" data-jci-custom-sync="fullprice"></span><span data-jci-custom-sync="price"></span>
          <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.227252 0.852252C0.446922 0.632583 0.803078 0.632583 1.02275 0.852252L7.77275 7.60225C7.99242 7.82192 7.99242 8.17808 7.77275 8.39775L1.02275 15.1477C0.803078 15.3674 0.446922 15.3674 0.227252 15.1477C0.00758251 14.9281 0.00758251 14.5719 0.227252 14.3523L6.5795 8L0.227252 1.64775C0.00758251 1.42808 0.00758251 1.07192 0.227252 0.852252Z" fill="currentColor"></path></svg>
        </button>
        
        <div class="jci-recharge-bundle--summary-items" data-jci-custom-sync="items">
          <ul>
            <li>
              <div class="jci-recharge-bundle--summary-item-media"></div>
              <div class="jci-recharge-bundle--summary-item-info">
                <div class="jci-recharge-bundle--summary-item-title"></div>
                <div class="jci-recharge-bundle--summary-item-qty"><span>-</span><span>1</span><span>+</span></div>
                <td class="jci-recharge-bundle--summary-item-price"></td>
              </div>
            </li>
          </ul>
          <table>
            <tbody>
              <tr>
                <td class="jci-recharge-bundle--summary-item-title"></td>
                <td class="jci-recharge-bundle--summary-item-qty"><span>-</span><span>1</span><span>+</span></td>
                <td class="jci-recharge-bundle--summary-item-price"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div id="jci-recharge-bundle--summary-mobile-trigger" class="jci-recharge-bundle--summary-mobile-trigger button button--small">
        Bundle Summary<span class="tstrike" data-jci-custom-sync="fullprice"></span><span data-jci-custom-sync="price"></span>
        <svg width="8" height="16" viewBox="0 0 8 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.227252 0.852252C0.446922 0.632583 0.803078 0.632583 1.02275 0.852252L7.77275 7.60225C7.99242 7.82192 7.99242 8.17808 7.77275 8.39775L1.02275 15.1477C0.803078 15.3674 0.446922 15.3674 0.227252 15.1477C0.00758251 14.9281 0.00758251 14.5719 0.227252 14.3523L6.5795 8L0.227252 1.64775C0.00758251 1.42808 0.00758251 1.07192 0.227252 0.852252Z" fill="currentColor"></path></svg>
      </div>
    `);

    /* Move Recharge's Frequency Selector before our Summary's Add to cart button */
    bundle.querySelector('.jci-recharge-bundle--summary-add-to-cart').
      insertAdjacentElement('beforebegin', bundle.querySelector('.rb-frequency-wrapper'));

    listenForSummaryRelatedMutationsAndUpdateOurOwn(buildABox);

    /* initialize summary with empty data */
    updateSummary( {
      'price': '',
      'fullprice': '',
      'addtocart': true, 
      'items': []
    });

    /* Relay click events */
    var summary = document.getElementById('jci-recharge-bundle--summary');
    summary.addEventListener('click', e => {
      if (e.target.matches('.jci-recharge-bundle--summary-item-qty span:first-child')) {
        /* REMOVE QTY */
        var itemId = e.target.closest('.jci-recharge-bundle--summary-item-qty').dataset.sourceItemId;
        var itemMinusButton = buildABox.querySelector('[data-rb-item-id="'+itemId+'"] .rb-btn-qty-minus');
        if (itemMinusButton) {
          itemMinusButton.dispatchEvent(new MouseEvent('click'));
        }
      } else if (e.target.matches('.jci-recharge-bundle--summary-item-qty span:last-child')) {
        /* ADD QTY  */
        var itemId = e.target.closest('.jci-recharge-bundle--summary-item-qty').dataset.sourceItemId;
        var itemPlusButton = buildABox.querySelector('[data-rb-item-id="'+itemId+'"] .rb-btn-qty-plus');
        if (itemPlusButton) {
          itemPlusButton.dispatchEvent(new MouseEvent('click'));
        }
      } else if (e.target.matches('.jci-recharge-bundle--summary-item-remove')) {
        /* REMOVE QTY UNTIL 0 */
        var itemId = e.target.closest('.jci-recharge-bundle--summary-item-info').querySelector('.jci-recharge-bundle--summary-item-qty').dataset.sourceItemId;
        var interval = setInterval( () => {
          var item =  buildABox.querySelector('[data-rb-item-id="'+itemId+'"]');
          var itemMinusButton = item.querySelector('.rb-btn-qty-minus');
          var itemQty = item.querySelector('input.rb-input').value;

          if (itemQty > 0 && itemMinusButton) {
            itemMinusButton.dispatchEvent(new MouseEvent('click'));
          } else {
            clearInterval(interval);
          }
        }, 100);
      } else if (e.target.matches('.jci-recharge-bundle--summary-add-to-cart, .jci-recharge-bundle--summary-add-to-cart *')) {
        /* ADD TO CART */
        buildABox.querySelector('.status-bar-sign-up .rb-form .rb-btn').dispatchEvent(new MouseEvent('click')); 
      }
    });

    document.getElementById('jci-recharge-bundle--summary-mobile-trigger').addEventListener('click', e=> {
      if (summary.dataset.openInMobile) {
        delete(summary.dataset.openInMobile);
      } else {
        summary.dataset.openInMobile = 'true';
      }
    });

    var incentiveStatusContainer = buildABox.querySelector('.rb-incentives-status__container');
    if (incentiveStatusContainer) {
      updateTierTitles(incentiveStatusContainer.parentElement);
    }

  }

  function listenForSummaryRelatedMutationsAndUpdateOurOwn(buildABox) {
    var target = buildABox.querySelector('.status-bar-sign-up');

    var config = { 
      subtree: true,
      childList: true,
      attributes: true,
      attributeOldValue: true
    };
    var mutationCallback = (mutationList, observer) => {
      var selected = '';
      if (target.querySelector('.thl-copy ')) {
        selected = [...target.querySelector('.thl-copy').childNodes]
          .filter(child => child.nodeName === '#text' )
          .filter(child => child.textContent.trim())
          .map(textNode => textNode.textContent);
      }
      var price = '';
      var fullPrice = '';
      if (target.querySelector('.thl-copy > :first-child')) {
        price = [...target.querySelector('.thl-copy > :first-child').childNodes]
          .filter(child => child.nodeName === '#text' )
          .filter(child => child.textContent.trim())
          .map(textNode => textNode.textContent);
        fullPrice = target.querySelector('.thl-copy .rb-full-price')?.textContent;
      }
      var addToCart = target.querySelector('.rb-btn').disabled;

      var totalQty = 0;

      var items = [];
      buildABox.querySelectorAll('.rb-item').forEach( item => {
        var qty = item.querySelector('.rb-input').value;
        if (qty > 0) {
          var id = item.dataset.rbItemId;
          var title = item.querySelector('.rb-title').textContent;
          var price = [...item.querySelector('.rb-price').childNodes]
            .filter(child => child.nodeName === '#text' )
            .filter(child => child.textContent.trim())
            .map(textNode => textNode.textContent);
          var fullPrice = item.querySelector('.rb-full-price')?.textContent;
          var imgsrc = item.querySelector('.rb-img img')?.src;

          items.push({
            'imgsrc': imgsrc, 
            'id': id,
            'title': title,
            'price': price,
            'fullprice': fullPrice,
            'qty': qty
          });

          totalQty += parseInt(qty);
        }
      });

      updateSummary( {
        'price': price,
        'totalqty': totalQty,
        'fullprice': fullPrice,
        'addtocart': addToCart, 
        'items': items,
        'selected': selected
      });
    };
    var observer = new MutationObserver(mutationCallback);
    observer.observe(target, config);

  }

  function updateSummary(data) {
    var summary = document.getElementById('build-a-box');
    var button = summary.querySelector('.jci-recharge-bundle--summary-add-to-cart');

    summary.querySelectorAll('[data-jci-custom-sync="selected"]').forEach( el => {
      el.textContent = data.selected; 
    });
    summary.querySelectorAll('[data-jci-custom-sync="price"]').forEach( el => {
      el.textContent = data.price ?? ''; 
    });
    summary.querySelectorAll('[data-jci-custom-sync="fullprice"]').forEach( el => {
      el.textContent = data.fullprice ?? ''; 
    });
    summary.querySelectorAll('[data-jci-custom-sync="addtocart"]').forEach( el => {
      el.disabled = data.addtocart;
    });

    if (typeof(window.jci_custom_bundle_tier_titles) !== 'undefined') { 
      summary.querySelectorAll('[data-jci-custom-sync="savings"]').forEach( el => {
        if (summary.querySelector('select.rb-select').selectedIndex !== 0) {
          el.textContent = "You're saving 15%"; // Fixed text — change as needed
        } else {
          el.textContent = "";
        }
      });
      // summary.querySelectorAll('[data-jci-custom-sync="savings"]').forEach( el => {
      //   var customTierQty = window.jci_custom_bundle_tier_titles.quantity.reduce((m,n) => {
      //     var retval = data.totalqty;
      //     if (n > m) {
      //       return Math.min(retval,n);
      //     } else {
      //       return Math.min(retval,m);
      //     }
      //   });
      //   customTierIdx = window.jci_custom_bundle_tier_titles.quantity.indexOf(customTierQty);

      //   if (summary.querySelector('select.rb-select').selectedIndex !== 0) {
      //     el.textContent = window.jci_custom_bundle_tier_titles.savings_title[customTierIdx];
      //   } else {
      //     el.textContent = "";
      //   }
      // });
    }
    summary.querySelectorAll('[data-jci-custom-sync="items"]').forEach( el => {
      if (data.items.length > 0 ) {
        var rows = '';
        for(i=0; i < data.items.length; i++) {
          var itemdata = data.items[i];
          rows += `
            <li>
              <div class="jci-recharge-bundle--summary-item-media"><img src="${itemdata.imgsrc}" /></div>
              <div class="jci-recharge-bundle--summary-item-info">
                <div class="jci-recharge-bundle--summary-item-title">${itemdata.title}<span aria-hidden="true" class="jci-recharge-bundle--summary-item-remove far fa-trash"></span></div>
                <div class="jci-recharge-bundle--summary-item-qty" data-source-item-id="${itemdata.id}"><span>-</span><span>${itemdata.qty}</span><span>+</span></div>
                <div class="jci-recharge-bundle--summary-item-price"><span class="tstrike">${itemdata.fullprice ?? ''}</span>&nbsp;${itemdata.price ?? ''}</div>
              </div>
            </li>
          `; 
        }
        el.innerHTML = `<ul>${ rows }</ul>`;
      } else {
        el.innerHTML = '';
      }
    });
  }

  function addCollectionTabsToRechargeBundle( bundle ) {
    var collectionTabsFormId = 'jci-recharge-bundle--collection-tabs';
    var categories = [];
    var oldCategories = [];
    var rbBoxBuilder = bundle.querySelector('.rb-box-builder');
    var tabHtmls = '';
    var checked = "checked";
    rbBoxBuilder.querySelectorAll('.rb-section').forEach( rbSection => {
      var title = rbSection.querySelector('.rb-section-title').textContent;
      var inputId = 'jci-recharge-bundle--collection-tab--' + rbSection.id;
      categories.push(title);
      tabHtmls += `<input id="${ inputId }" type="radio" value="${ rbSection.id }" name="collection" ${ checked }><label for="${ inputId }">${title}</label>`;
      if (checked !== '') {
        rbSection.style.display = 'block';
      }
      checked = "";
    });
    var tabsHtml = `<form id="${ collectionTabsFormId }" class="jci-recharge-bundle--collection-tabs">${tabHtmls}</fieldset>`;

    const existingTabs = bundle.querySelector('#' + collectionTabsFormId);
    bundle.querySelectorAll('#' + collectionTabsFormId + ' input[type=radio] + label').forEach( radioLabel => oldCategories.push(radioLabel.textContent));

    const hasNewCategories = (JSON.stringify(categories) !== JSON.stringify(oldCategories));

    if (hasNewCategories && existingTabs != null) {
      console.log('JCI: Collection tabs removed.');
      existingTabs.remove();
    }

    if (hasNewCategories) {
      rbBoxBuilder.insertAdjacentHTML('beforebegin', tabsHtml);

      var collectionTabs = bundle.querySelector('#' + collectionTabsFormId);
      collectionTabs.addEventListener('change', (e) => {
        var formData = new FormData(e.currentTarget);
        var rbSectionId = formData.get('collection');
        rbBoxBuilder.querySelectorAll('.rb-section').forEach( rbSection => {
          if (rbSection.id == rbSectionId) {
            rbSection.style.display = 'block';
          } else {
            rbSection.style.display = '';
          }
        });
      });
      console.log('JCI: Collection tabs generated. (' + JSON.stringify(categories) + ')');
    }
  }

  function injectCSS() {

    var styleSheet = document.createElement("style");
    styleSheet.innerText = `
      /* Fix sticky functionality */
      .template--recharge-bundle #MainContent {
        overflow-x: unset;
      }


      #build-a-box > .status-bar-sign-up {
        display: none; 
      }

      /* For Summary */
      .jci-recharge-bundle--summary {
        background-color: #eee9e4;
        padding: 2.5rem;
        box-shadow: 0 6px 10px -4px #0000004a;
        box-shadow: 0 6px 10px -4px #0000003a, 0 0 1px 0 #cabaab;
        border-radius: 10px 10px 0 0;

        position: fixed;
        top:100%;
        width: 100%;
        left: 0;
        right: 0;
        z-index:3;
        transition: transform 250ms;

        border-bottom: 1px solid rgba(0,0,0,.25);

        max-height: calc(100vh - 48px);
        overflow-y: scroll;
      }
      .jci-recharge-bundle--summary-mobile-trigger {
        position: fixed;
        width: 100%;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 0;
        z-index: 3;
        background-color: #4c4848;
        background-color: #eee9e4;
        color: var(--rb-body-color);
      }
      .jci-recharge-bundle--summary-mobile-trigger > span {
        margin-left: .33em;
      }
      .jci-recharge-bundle--summary-mobile-trigger > svg {
        position: absolute;
        right: 2.5rem;
        transform: rotate(-90deg);
        transition: transform 250ms;
      }
      .jci-recharge-bundle--summary-mobile-trigger .tstrike {
        opacity: .33;
      }

      .jci-recharge-bundle--summary h5 {
        margin: 10px 0;
        text-align: center;
      }
      .jci-recharge-bundle--summary-items {
        min-height: 156px;
      }
      .jci-recharge-bundle--summary-items:not(:empty) {
        font-size: 13px;
        margin-top: 2rem;
      }
      .jci-recharge-bundle--summary-items ul {
        list-style: none;
        padding: 0;
      }
      .jci-recharge-bundle--summary-items ul li {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
      }
      .jci-recharge-bundle--summary-item-media {
        flex: 0 0 fit-content;
        font-size: 0;
      }
      .jci-recharge-bundle--summary-items ul li img {
        width: 75px;
        height: 75px;
      }
      .jci-recharge-bundle--summary-item-info {
        flex: 1 1 auto;
        
        display: flex;
        flex-flow: row wrap;
        padding: 0 0 0 20px;
        justify-content: space-between;

        gap: 6px;
      }
      .jci-recharge-bundle--summary-item-title {
        width: 100%;
        line-height: 1.2;
        position: relative;
      }
      .jci-recharge-bundle--summary-item-remove {
        font-family: 'Font Awesome 5 Pro';
        font-weight: 400;
        opacity: 0.33;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        cursor: pointer;
      }
      .jci-recharge-bundle--summary-item-qty,
      .jci-recharge-bundle--summary-item-price {
        line-height: 2;
      }
      .jci-recharge-bundle--summary-items table {
        width: 100%;
        box-shadow: none;
      }
      .jci-recharge-bundle--summary-items table td {
        padding-left: 0;
        border: none;
        padding-top: 0;
        padding-bottom: 4px;
      }
      .jci-recharge-bundle--summary-items table td:last-child {
        padding-right: 0;
      }
      .jci-recharge-bundle--summary-item-price .tstrike {
        opacity: .33;
      }
      .jci-recharge-bundle--summary-add-to-cart {
        width: 100%;
      }
      .jci-recharge-bundle--summary-add-to-cart > span {
        margin-left: .33em;
      }
      .jci-recharge-bundle--summary-add-to-cart .tstrike {
        opacity: .33;
        display: none; /* hide, too messy */
      }
      .jci-recharge-bundle--summary-item-qty span {
        background: white;
        display: inline-block;
        width: 2em;
        text-align: center;
        cursor: arrow;
        pointer-events: none;
        line-height: 2em;
      }
      .jci-recharge-bundle--summary-item-qty span:first-child {
        border-radius: 1em 0 0 1em;
        cursor: pointer;
        pointer-events: all;
        padding-left: .5em;
      }
      .jci-recharge-bundle--summary-item-qty span:last-child {
        border-radius: 0 1em 1em 0;
        cursor: pointer;
        pointer-events: all;
        padding-right: .5em;
      }

      .shopify-section-header-sticky ~ #MainContent .rb-box-builder .rb-section-header {
        top: 56px !important;
      }

      .jci-recharge-bundle--summary-tier-savings {
        text-align: center;
        margin-top: -10px !important;
        display: block !important;
      }
      .jci-recharge-bundle--summary-tier-savings::before {
        content: '';
        display: inline-block;
      }

      #build-a-box .rb-frequency {
        display: flex;
        border: 1px solid red;
        border-radius: var(--rb-select-radius);
        border-color: var(--color-buttons-primary);
        margin-bottom: 16px !important;
        max-width: 100%;
        overflow: hidden;
      }
      #build-a-box .rb-frequency .rb-label, .rb-frequency .rb-select {
        text-transform: uppercase;
        font-size: 13px;
        font-weight: 500;
        font-family: "Karla", sans-serif;
        letter-spacing: normal;
        appearance: none;
        line-height: 41px;
      }
      #build-a-box .rb-frequency .rb-label {
        flex-grow: 0;
        width: max-content;
        padding: 0 1em;
        margin: 0;
      }
      #build-a-box .rb-frequency .rb-select {
        flex: 1;
        line-height: 37px;
        background: var(--color-buttons-primary);
        color: #fff;
        border-radius: 0 var(--rb-select-radius) var(--rb-select-radius) 0;
        margin: 0;
        border: none;
        padding-left: 1em;

        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" fill="white"/></svg>');
        background-size: 10px;
        background-repeat: no-repeat;
        background-position: calc(100% - 14px);
        pading-right: 0;
      }
      #build-a-box .rb-sticky-form {
        display: none;
      }
      #build-a-box .rb-header {
        padding-bottom: var(--spacing-medium);
      }

      .rb-section-header {
        pointer-events: none;
      }

      /* Desktop Layout */
      @media screen and (min-width: 960px) {

        #build-a-box {
          display: flex;
          align-items: flex-start;
          --rb-item-width: calc((100% - 1px) / 3);
        }
        #build-a-box > :first-child {
          width: 66%;
        }

        .shopify-section-header-sticky ~ #MainContent .jci-recharge-bundle--summary,
        .shopify-section-header-sticky ~ #MainContent .rb-box-builder .rb-section-header {
          top: 75px !important;
        }

        .jci-recharge-bundle--summary {
          /* top: 36px !important; */
          position: sticky;
          width: 100%;

          margin-left: 2.4rem;
          margin-bottom: 2.5rem;
          top: 2.4rem;

          bottom: unset;
          left: unset;
          right: unset;

          border-radius: 10px;

          max-height: calc(100vh - 130px);
        }
        .jci-recharge-bundle--summary-items:not(:empty) {
          font-size: 14px;
        }
        .jci-recharge-bundle--summary-mobile-trigger {
          display: none;
        }

      .rb-section-header {
        pointer-events: all;
      }
      .rb-section-header::before, 
      .rb-section-header::after {
        content: '';
        position: absolute;
        right: 10px;
        width: 16px;
        height: 2px;
        background: black;
        margin-top: auto;
        margin-bottom: auto;
        top: 0;
        bottom: 0;
        transition: transform 250ms;
      }
      .rb-section-header:not(.jci-open)::after {
        transform: rotate(90deg);
      }
      }
      @media screen and (min-width: 1280px) {
        #build-a-box {
          --rb-item-width: calc((100% - 1px) / 4);
        }
      }

      #jci-recharge-bundle--collection-tabs {
        display: none;
      }
      @media screen and (max-width: 959px) {
        .rb-section {
          display: none;
        }
        .rb-section > section {
          display: block !important;
        }

        /*
        #jci-recharge-bundle--collection-tabs + .rb-box-builder {
          padding-left: 0;
          padding-right: 0;
        }
        */

        #jci-recharge-bundle--collection-tabs {
          display: flex;
          gap: 5px;
          overflow-x: scroll;
          margin-left: -2.4rem;
          margin-right: -2.4rem;
          padding-left: calc(2.4rem + (1px * var(--rb-page-padx)));
          padding-right: calc(2.4rem + (1px * var(--rb-page-padx)));
        }
        #jci-recharge-bundle--collection-tabs input {
          display: none;
        }
        #jci-recharge-bundle--collection-tabs label {
          display: ;
          padding: var(--rb-btn-pady) var(--rb-btn-padx);
          border: 1px solid currentColor;
          border-radius: var(--rb-btn-radius);
          white-space: nowrap;
        }
        #jci-recharge-bundle--collection-tabs :checked + label {
          background: var(--rb-btn-bg);
          color: var(--rb-btn-color);
          border: 1px solid var(--rb-btn-bg);
        }
        #jci-recharge-bundle--collection-tabs label:hover {
          background: var(--rb-btn-bg-hover);
          color: var(--rb-btn-color-hover);
          border: 1px solid var(--rb-btn-bg-hover);
        }
        .jci-recharge-bundle--summary[data-open-in-mobile] {
          transform: translateY(calc(-100% - 48px));
        }
        .jci-recharge-bundle--summary[data-open-in-mobile] + .jci-recharge-bundle--summary-mobile-trigger > svg {
          transform: rotate(90deg);
        }
      }
      @media screen and (max-width: 767px) {
        #jci-recharge-bundle--collection-tabs {
          padding-left: calc(2.4rem + var(--rb-page-padx));
          padding-right: calc(2.4rem + var(--rb-page-padx));
        }
      }

      /* Hide broken popup tooltip */
      .v-popper__popper {
        display: none;
      }

    `;
    document.head.appendChild(styleSheet);
  }

  function slideUp(target, duration=500) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout( () => {
          target.style.display = 'none';
          target.style.removeProperty('height');
          target.style.removeProperty('padding-top');
          target.style.removeProperty('padding-bottom');
          target.style.removeProperty('margin-top');
          target.style.removeProperty('margin-bottom');
          target.style.removeProperty('overflow');
          target.style.removeProperty('transition-duration');
          target.style.removeProperty('transition-property');
          //alert("!");
    }, duration);
  }

  /* SLIDE DOWN */
  function slideDown(target, duration=500) {

    target.style.removeProperty('display');
    let display = window.getComputedStyle(target).display;
    if (display === 'none') display = 'block';
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout( () => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }

  document.addEventListener('DOMContentLoaded', initJCIRechargeCustomizations);
})();
